import React from "react";
import Classes from "./styles/style.module.css";

const CustomButton = ({ text, clickHandler, color, shadow, styles, id, type, disabled, className = "", title, "aria-label": ariaLabel }) => {
  return (
    <button
      id={id}
      type={type}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
      className={`${Classes.customButton} ${
        color
          ? color === "primary"
            ? Classes.primary
            : Classes.secondary
          : Classes.primary
      } ${shadow ? Classes.shdow : ""} ${className}`}
      onClick={clickHandler}
      style={styles}
    >
      {text}
    </button>
  );
};

export default CustomButton;
